export default {
  title: "Onlayn-katalog",
  tabs: {
    products: "Mahsulotlar va xizmatlar",
    categories: "Kategoriyalar",
  },
  buttons: {
    qrCode: "QR-kod",
    create: "Yaratish",
  },
  modals: {
    limit: {
      title: "Siz tarifingiz bo‘yicha maksimal mahsulotlar sonini yaratdingiz",
      subtitle: "Ko‘proq mahsulot yaratish uchun tarifni oshiring.",
      cancel: "Bekor qilish",
      toTariffs: "Tariflarga",
    },
  },
  statuses: {
    allProducts: "Barcha mahsulotlar",
    allCategories: "Barcha kategoriyalar",
    confirmed: "Tasdiqlangan",
    moderation: "Moderatsiyada",
    rejected: "Rad etilgan",
    basic: "Asosiy",
  },
  emptyState: {
    products: {
      noTradingPoints: {
        title: "Onlayn-katalogda hali mahsulotlar yo‘q",
        description:
          "Avvalo savdo nuqtasini yarating, so‘ngra mahsulot qo‘shishingiz mumkin",
        buttonText: "Savdo nuqtalariga",
      },
      noProducts: {
        title: "Onlayn-katalogda hali mahsulotlar yo‘q",
        buttonText: "Mahsulot yaratish",
      },
    },
    categories: {
      title: "Hozircha ma’lumot yo‘q",
      description:
        "Ular mahsulot yaratilib, asosiy kategoriyalardan biriga biriktirilganda paydo bo‘ladi. Yoki foydalanuvchi kategoriyasi yaratilganda.",
      buttonText: "Kategoriya yaratish",
    },
  },
  formErrors: {
    empty: "Maydon bo‘sh bo‘lishi mumkin emas",
    price: "Qiymat 0 dan katta bo‘lishi kerak",
    discount: "Qiymat chegirmasiz narxdan kam bo‘lishi kerak",
  },
  exitModal: {
    creating: {
      title: "Mahsulot yaratishni bekor qilmoqchimisiz?",
      subtitle:
        "Kiritilgan mahsulot ma’lumotlari saqlanmaydi. Tahrirga qaytish uchun «Orqaga» tugmasini bosing.",
      backButton: "Orqaga",
      confirmButton: "Ha, bekor qilish",
    },
    editing: {
      title: "Kiritilgan o‘zgarishlarni o‘chirmoqchimisiz?",
      subtitle:
        "Agar saqlamoqchi bo‘lsangiz, orqaga qayting. Aks holda barcha o‘zgarishlar qo‘llanmaydi. Mahsulot kartasida oldingi saqlangan ma’lumotlar ko‘rsatiladi.",
      backButton: "Orqaga va saqlash",
      confirmButton: "O‘chirish",
    },
  },
  categoryEditModal: {
    title: {
      rejected: "Kategoriya moderator tomonidan rad etildi",
      default: "Kategoriya nomini kiriting",
    },
    subtitle: {
      rejected: "Nomni o‘zgartiring va kategoriyani moderatsiyaga yuboring.",
      rejectedWithMessage:
        "Nomni o‘zgartiring va kategoriyani moderatsiyaga yuboring.",
      default:
        "Kategoriya yangi mahsulotlar yaratishda tanlanishi mumkin bo‘ladi va RC PAYda nomi ko‘rsatilgan holda faqat moderatsiyadan o‘tganidan keyin paydo bo‘ladi.",
    },
    buttons: {
      cancel: "Bekor qilish",
      sendForModeration: "Moderatsiyaga",
    },
    notification: {
      success: "Kategoriya moderatsiyaga yuborildi",
    },
  },
  categoryDeleteModal: {
    title: "«{name}» kategoriyasini o‘chirmoqchimisiz?",
    subtitle:
      "Unga tegishli mahsulotlarga asosiy qiymat «Kategoriyasiz» beriladi",
    buttons: {
      cancel: "Bekor qilish",
      delete: "O‘chirish",
    },
    notification: {
      deleted: "Kategoriya o‘chirildi",
    },
  },
  productCard: {
    labels: {
      name: "Mahsulot nomi",
      category: "Kategoriya",
      measurementUnit: "O‘lchov birligi",
      price: "Narx, {currency}",
      discountPrice: "Chegirmali narx, {currency}",
      sku: "Artikul",
      barcode: "Shtrix-kod",
      description: "Tavsif",
      tradingPointsVisibility: "Savdo nuqtalarida ko‘rinishi",
      productImages: "Mahsulot rasmlari",
      showInCatalog: "Onlayn-katalogda ko‘rsatish",
      showInCatalogDescription:
        "Mahsulot moderatsiyadan o‘tganidan so‘ng, tanlangan savdo nuqtalarining RC PAY Onlayn-katalogida ko‘rsatiladi.",
    },
    placeholders: {
      selectCategory: "Kategoriya tanlang",
      selectMeasurementUnit: "O‘lchov birligini tanlang",
      sku: "30 belgigacha",
      selectTradingPoints: "Savdo nuqtalarini tanlang",
    },
    buttons: {
      cancel: "Bekor qilish",
    },
    notifications: {
      fillRequiredFields: "Barcha majburiy maydonlarni to‘liq to‘ldiring",
    },
    moderationMessage: {
      title: "Moderatsiyadan xabar",
    },
    measurementUnits: {
      none: "O‘lchov birligisiz",
    },
    imageRequirements: {
      aspectRatio: "Rasm nisbati — 1:1",
      fileTypes: "JPEG, JPG, PNG — 5 ta fayl, har biri 10 MB dan oshmasin",
    },
    imageCropper: {
      subtitle:
        "Tanlangan maydon RC PAY Onlayn-katalogidagi mahsulot kartasida ko‘rsatiladi.",
    },
  },
  productsTableHeader: {
    columns: {
      name: "Nomi",
      category: "Kategoriya",
      price: "Narx",
      status: "Holat",
    },
  },
  productsDeleteModal: {
    title: "Ko‘rsatilgan mahsulotni o‘chirmoqchimisiz?",
    buttons: {
      cancel: "Bekor qilish",
      delete: "O‘chirish",
    },
  },
  productsQRModal: {
    title: "Menyu uchun QR-kod",
    subtitle:
      "Qaysi savdo nuqtasi uchun QR-kodni yuklab olmoqchi ekanligingizni tanlang",
    tradingPoint: "Savdo nuqtasi",
    downloadButton: "QR-kodni yuklab olish",
  },
  productsSaveModal: {
    title: "Ba’zi o‘zgarishlar moderatsiyani talab qiladi",
    subtitle:
      "Mahsulot kartasida RC PAYda ular faqat moderator tomonidan tasdiqlangandan keyin yangilanadi.",
    buttons: {
      cancel: "Bekor qilish",
      sendForModeration: "Moderatsiyaga",
    },
  },
  productVisible: {
    messages: {
      visible: "RC PAYda ko‘rsatilgan",
      hidden: "RC PAYda yashirilgan",
    },
  },
  categoriesFilters: {
    sort: {
      newFirst: "Avvalo yangi yaratilganlar",
      alphabeticalAsc: "Noma bo‘yicha A dan Z gacha",
      alphabeticalDesc: "Noma bo‘yicha Z dan A gacha",
      productsCountAsc: "Kamroq mahsulotlar avvalo",
      productsCountDesc: "Ko‘proq mahsulotlar avvalo",
    },
    buttons: {
      create: "Yaratish",
    },
    search: {
      placeholder: "Kategoriyalar bo‘yicha qidirish",
    },
    status: {
      label: "Kategoriya holati",
    },
  },
  productFilters: {
    sort: {
      newFirst: "Avvalo yangi yaratilganlar",
      alphabeticalAsc: "Noma bo‘yicha A dan Z gacha",
      alphabeticalDesc: "Noma bo‘yicha Z dan A gacha",
      priceAsc: "Narx oshish bo‘yicha",
      priceDesc: "Narx kamayish bo‘yicha",
    },
    buttons: {
      create: "Yaratish",
    },
    search: {
      placeholder: "Qidirish",
    },
    labels: {
      category: "Kategoriya",
      tradingPoints: "Savdo nuqtalari",
      status: "Holat",
    },
  },
  productDrawer: {
    title: {
      edit: "Mahsulot haqida ma’lumot",
      create: "Mahsulot yaratish",
    },
    saveButton: {
      saveAndExit: "Saqlash va chiqish",
      sendForModeration: "Moderatsiyaga",
    },
    errors: {
      imageUpload: "Ba’zi rasmlar yuklanmadi. Boshqa rasmlarni yuklab ko‘ring.",
    },
  },
  categoryGroup: {
    system: "Asosiy",
    confirm: "Tasdiqlangan",
    moderation: "Moderatsiyada",
    reject: "Rad etilgan",
  },
  sysCategory: {
    autoLubrication: "Avtomobil moylash ",
    autoDisks: "Avtomobil disklari",
    autoOils: "Avtomobil motor moylari ",
    autoTires: "Avtomobil shinalari",
    carWash: "Avtomobil yuvish",
    accumulator: "Akkumulyator",
    accessories: "Aksessuarlar",
    antifreeze: "Antifriz ",
    rentMovableProperty: "Ko'chmas mulk ijarasi (harakatlanuvchi)",
    rentImmovableProperty: "Ko'chmas mulk ijarasi",
    householdAppliances: "Maishiy texnika",
    householdChemicals: "Maishiy kimyo",
    sideDishes: "Garnirlar",
    gelSystems: "Gel tizimlari",
    hotDishes: "Issiq ovqat ",
    grill: "Grill",
    dysenfyingDetergents: "Dezinfeksiyalovchi yuvish vositalari",
    deserts: "Desertlar",
    forChildren: "Bolalar uchun",
    forAnimals: "Hayvonlar uchun ",
    forHoliday: "Bayram uchun",
    homeTextiles: "Uy to'qimachiligi",
    breakfast: "Nonushta",
    snacks: "Gazaklar",
    spareParts: "Ehtiyot qismlar ",
    health: "Sog'liq",
    toys: "O'yinchoqlar",
    furnitureManufacturing: "Mebel ishlab chiqarish",
    medicals: "Tibbiy maqsadli buyumlar",
    instruments: "Asboblar",
    chancellery: "Kantselyariya",
    books: "Kitoblar",
    laboratoryUtensils: "Laboratoriya idishlari",
    furniture: "Mebel",
    medicalInstruments: "Tibbiy asboblar",
    medicalTechDevices: "Tibbiy texnik qurilmalar",
    perennialFlowers: "Ko'p yillik gullar",
    drinks: "Ichimliklar",
    equipment: "Uskunalar",
    shoes: "Poyabzal",
    clothes: "Kiyim",
    parfumeCosmetic: "Parfyumeriya va kosmetika",
    pasta: "Pasta",
    pizza: "Pitsa",
    gifts: "Sovg'alar",
    printingProducts: "Poligrafik mahsulotlar",
    dishes: "Idish-tovoq ",
    products: "Mahsulotlar ",
    foodProducts: "Oziq-ovqat",
    repairFinishingWork: "Ta'mirlash / Bitirish ishlari",
    gardenFertilizers: "Bog' o'g'itlari",
    seedlings: "Ko'chatlar",
    salads: "Salatlar ",
    sauces: "Souslar",
    sport: "Sport",
    hairCareProducts: "Soch parvarishi vositalari",
    buildingMaterials: "Qurilish materiallari",
    building: "Qurilish",
    soups: "Sho'rvalar",
    gardenProducts: "Bog'dorchilik tovarlari",
    brakeFluid: "Tormoz suyuqligi",
    tosol: "Tosol",
    services: "Xizmatlar",
    insuranceServices: "Sug'urta xizmatlari",
    care: "G'amxo'rlik ",
    filter: "Filtr",
    fitnessLanch: "Fitnes tushliklari",
    photoProducts: "Foto tovarlar",
    chemicalReagents: "Kimyoviy reagentlar",
    bread: "Non",
    hobbies: "Qiziqish",
    flowers: "Gullar ",
    tireRepair: "Shinalarni montaj qilish",
    ecoWashProducts: "Ekologik tozalash vositalari",
    electric: "Elektronika",
    legalServices: "Yuridik xizmatlar",
    noCategory: "Kategoriyasiz",
  },

  hideInRcPay: "{str}RC PAYda yashirish",
  showInRcPay: "{str}RC PAYda ko‘rsatish",
  removeProduct: "Mahsulotni o‘chirish",
  checkProducts: "Mahsulotlarni ko‘rish",
  changeNaming: "Nomini o‘zgartirish",
  removeCategory: "Kategoriyani o‘chirish",
  product: "Mahsulot",
  message: {
    productHidden: "Mahsulot RC PAYda yashirildi",
    productShown: "Mahsulot RC PAYda ko‘rsatildi",
  },
  categoryName: "Kategoriya nomi",
  productsAmount: "Mahsulotlar soni",
  status: "Status",
};
